import { render, staticRenderFns } from "./usertop.vue?vue&type=template&id=bad5ce38&scoped=true&"
import script from "./usertop.vue?vue&type=script&lang=js&"
export * from "./usertop.vue?vue&type=script&lang=js&"
import style0 from "./usertop.vue?vue&type=style&index=0&id=bad5ce38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad5ce38",
  null
  
)

export default component.exports